import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import InventoryContentsTableAdd from './InventoryContentsTableAdd';
import InventoryContentsTableRow from './InventoryContentsTableRow';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
    TableBody
} from 'material-ui';

/**
 * A component for generating rows of editable InventoryCollectionTableRows.
 *
 */
class InventoryContentsTable extends Component {
    constructor(props) {
        super(props);

        // Set Location ID
        const createdBy = this.props.created_by_client;
        let locationId = (createdBy && createdBy.location) ? createdBy.location.toString() : null;

        // Set Repack/Retail Box text
        let type = this.props.type;
        let typeName = 'Repack/Retail Box';
        if (type) {
            if (type === 'repack') {
                typeName = 'Repack';
            }
            if (type === 'retail_box') {
                typeName = 'Retail Box';
            }
        }
        this.state = {
            addStatus: null,
            contents: this.props.contents,
            location: {
                city: null,
                dba: {
                    id: null,
                    name: null,
                    product_type: null
                },
                id: locationId,
                name: null,
                state: null
            },
            locationId: locationId,
            productUnitAdded: false,
            selectedProductType: null,
            selectedProductUnit: {
                id: null,
                qty: 0,
                unit_qty: 0,
                unit_type: null
            },
            typeName: typeName
        };
    }

    componentWillMount() {
        if (this.props.viewType === 'edit') {
            this.props.dispatch(change('add-inventory-form', 'add_product_unit_qty', 1));
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.contents !== this.props.contents ||
            nextProps.created_by_client !== this.props.created_by_client
        ) {
            // Set Location ID (for Add component to retrieve data)
            const createdBy = nextProps.created_by_client;
            let locationId = (createdBy && createdBy.location) ? createdBy.location.toString() : null;
            this.setState({
                addStatus: null,
                contents: nextProps.contents,
                locationId: locationId
            });
        }
    }

    /**
     * Process Location information from Add Product Unit component
     *
     * @param location
     */
    handleOnLocation = (location) => {
        // Do nothing with Location
    };

    updateContentsRow = (type, id, value) => {
        // Locate the item in list of contents
        let contents = JSON.parse(JSON.stringify(this.props.contents));
        const idx = contents.findIndex(e => e.barcode === id);
        if (idx !== -1) {
            // If the quantity was changed:
            if (type === 'qty') {
                contents[idx].qty = parseInt(value, 10);
            }
            // If the item has been removed:
            if (type === 'remove') {
                contents.splice(idx, 1);
            }
            this.setState({
                addStatus: null,
                contents: contents
            }, () => {
                this.props.dispatch(change('record-form', 'contents', contents));
            });
        }
    };

    /**
     * Process Add Product Unit to contents array
     *
     * @param productUnit
     */
    addToContents = (productUnit) => {
        let contents = JSON.parse(JSON.stringify(this.props.contents));
        const idx = contents.findIndex(e => e.barcode === productUnit.id);
        if (idx === -1) {
            const newProductUnit = {
                product: productUnit.product_id,
                barcode: productUnit.id,
                unit_type: productUnit.unit_type,
                unit_qty: 1,
                qty: productUnit.qty,
                product_name: productUnit.name
            };
            contents.push(newProductUnit);

            this.setState({
                addStatus: null,
                contents: contents
            }, () => {
                this.props.dispatch(change('record-form', 'contents', contents));
                this.props.dispatch(change('add-inventory-form', 'product_unit_select', null));
                this.props.dispatch(change('add-inventory-form', 'add_product_unit_qty', 1));
            });
        } else {
            this.setState({
                addStatus: 'duplicate'
            }, () => {
                this.props.dispatch(change('add-inventory-form', 'product_unit_select', null));
                this.props.dispatch(change('add-inventory-form', 'add_product_unit_qty', 1));
            });
        }
    };

    // Create table rows of Collection Content items
    makeInventoryContentsTable = (list, viewType) => {
        if (!list || !list.length) {
            const styles = {
                columnSmall: {paddingLeft: 10, paddingRight: 10},
            };
            return (
                <TableRow>
                    <TableRowColumn colSpan={4} style={styles.columnSmall}>No Contents</TableRowColumn>
                    <TableRowColumn style={styles.columnSmall}>&nbsp;</TableRowColumn>
                    <TableRowColumn style={styles.columnSmall}>&nbsp;</TableRowColumn>
                </TableRow>
            )
        }

        return (
            list.map((item, index) => (
                <InventoryContentsTableRow
                    key={`contents-${item.barcode}-${index}`}
                    data={item}
                    viewType={viewType}
                    onQtyChange={this.updateContentsRow}
                />
            ))
        )
    };

    render() {
        const {
            contents,
            viewType
        } = this.props;

        const {
            addStatus,
            locationId,
            typeName
        } = this.state;

        const styles = {
            tableCard: {display: 'block', margin: '1em 0 0 0'},
            columnSmall: {paddingLeft: 10, paddingRight: 10},
            columnEdit: {width: 142, minWidth: 142, paddingLeft: 10, paddingRight: 10}
        };

        return (
            <Card key="inventory-contents-table-card" style={styles.tableCard} initiallyExpanded>
                <CardHeader title="Contents" actAsExpander={true} showExpandableButton={true}/>
                <CardText expandable={true}>

                    {/* Table: Contents */}

                    <Table selectable={false} multiSelectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow key="inventory-contents-table-header-row">
                                <TableHeaderColumn style={styles.columnSmall}>Product<br/>Barcode</TableHeaderColumn>
                                <TableHeaderColumn style={styles.columnSmall}>
                                    Product Unit<br/>Barcode
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.columnSmall}>Product</TableHeaderColumn>
                                <TableHeaderColumn style={styles.columnSmall}>Unit Type</TableHeaderColumn>
                                {viewType === 'show' &&
                                <TableHeaderColumn style={styles.columnSmall}>Qty</TableHeaderColumn>
                                }
                                {viewType === 'show' &&
                                <TableHeaderColumn style={styles.columnSmall}>Unit Qty</TableHeaderColumn>
                                }
                                {viewType === 'edit' &&
                                <TableHeaderColumn
                                    style={{...styles.columnSmall, ...styles.columnEdit}}>Qty</TableHeaderColumn>
                                }
                                {viewType === 'edit' &&
                                <TableHeaderColumn
                                    style={{...styles.columnSmall, ...styles.columnEdit}}>Remove</TableHeaderColumn>
                                }
                            </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            {[...this.makeInventoryContentsTable(contents, viewType)]}
                        </TableBody>
                    </Table>

                    {/* Edit: Add Product Unit to Repack/Retail Box */}

                    {viewType === 'edit' &&
                    <InventoryContentsTableAdd
                        key="inventory-contents-table-add"
                        typeName={typeName}
                        locationId={locationId}
                        onAddProductUnit={this.addToContents}
                        addStatus={addStatus}
                        onLocation={this.handleOnLocation}
                    />
                    }
                </CardText>
            </Card>
        )
    }
}

InventoryContentsTable.propTypes = {
    contents: PropTypes.array,
    viewType: PropTypes.string
};

InventoryContentsTable.defaultProps = {
    contents: [],
    viewType: 'show'
};

function mapStateToProps(state, props) {
    let form = state.form['record-form'];
    if (form && form.values) {
        const contentsValue = (form.values['contents']) ? form.values['contents'] : [];
        return {
            contents: contentsValue
        }
    }
    return {};
}

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(InventoryContentsTable);



// WEBPACK FOOTER //
// ./src/Fuse/components/InventoryContentsTable.js